module.exports = __webpack_public_path__ + "static/media/pic8.47a6923f.jpg";